import AppRoutes from "AppRoutes";
import { createLogger } from "logging";
import { TaskModel } from "models/TaskModel";
import { useEditTask, useLayout } from "providers";
import { useTask } from "providers";
import { useTranslations } from "providers";
import React, { PropsWithChildren } from "react";
import { Item, Menu, TriggerEvent, useContextMenu } from "react-contexify";

import { TasksContextMenuContext } from "./TasksContextMenuContext";

const menuId = "tasks-context-menu";

const logger = createLogger("TasksContextMenuProvider");

export const TasksContextMenuProvider: React.FC<PropsWithChildren<unknown>> = ({ children }) => {
  const i18n = useTranslations();
  const { setSelectTaskId, setConfirmDeleteTask } = useTask();
  const { setEditTaskId } = useEditTask();
  const { show } = useContextMenu({ id: menuId });
  const { handleNavClick } = useLayout();

  function onClickDelete(item: TaskModel) {
    logger.debug("onClickDelete(): ", item);
    setConfirmDeleteTask({ id: item.id, title: item.title });
  }

  function showContextMenu(event: TriggerEvent, item: TaskModel) {
    logger.debug("showContextMenu(): ", item);
    setSelectTaskId(item.id);
    show({ event, id: menuId, props: item });
  }

  function onClickViewHistory(item: TaskModel): void {
    logger.debug("onClickViewHistory(): ", item);
    const url = AppRoutes.toBackendAuditLog("Task", item.id.toString());
    handleNavClick(url);
  }

  function onClickEdit(item: TaskModel): void {
    logger.debug("onClickEdit(): ", item);
    setEditTaskId(item.id);
  }

  function isDisabledEdit(item: TaskModel): boolean {
    return !item.canEdit;
  }

  function isDisabledViewHistory(item: TaskModel) {
    if (!item) return true;
    return !item.canViewHistory;
  }

  function isDisabledDelete(item: TaskModel) {
    if (!item) return true;
    return !item.canDelete;
  }

  return (
    <TasksContextMenuContext.Provider
      value={{
        showContextMenu,
      }}
    >
      <Menu id={menuId} theme="sbb">
        <Item onClick={(e) => onClickEdit(e.props)} disabled={(e) => isDisabledEdit(e.props)}>
          {i18n.Actions_Edit_Task}
        </Item>
        <Item onClick={(e) => onClickDelete(e.props)} disabled={(e) => isDisabledDelete(e.props)}>
          {i18n.Actions_Delete_Task_Title}
        </Item>
        <Item onClick={(e) => onClickViewHistory(e.props)} disabled={(e) => isDisabledViewHistory(e.props)}>
          {i18n.Actions_View_History}
        </Item>
      </Menu>

      {children}
    </TasksContextMenuContext.Provider>
  );
};
